import React, { useEffect, useRef } from 'react';
import { apiConfig } from '../config/authConfig';

function OfficeViewer({ file, url, onClose, token }) {
  const containerRef = useRef(null);
  const editorRef = useRef(null);
  const ONLYOFFICE_URL = "https://office.hopscotch.one";

  const getDocumentType = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    const types = {
      doc: 'word', docx: 'word',
      xls: 'cell', xlsx: 'cell',
      ppt: 'slide', pptx: 'slide'
    };
    return types[ext] || 'word';
  };

  useEffect(() => {
    if (!file || !url || !containerRef.current) return;

    if (editorRef.current) {
      try { editorRef.current.destroyEditor(); } catch(e) {}
      editorRef.current = null;
    }
    const oldScript = document.getElementById('onlyoffice-api-script');
    if (oldScript) oldScript.remove();

    const loadEditor = async () => {
      try {
        const docKey = `doc_${Date.now()}`;
        const docType = getDocumentType(file.name);
        const fileType = file.name.split('.').pop().toLowerCase();

        const tokenResponse = await fetch(`${apiConfig.baseUrl}/get-office-token`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            url: url,
            key: docKey,
            title: file.name,
            documentType: docType,
            fileType: fileType,
          }),
        });

        const tokenData = await tokenResponse.json();

        const script = document.createElement('script');
        script.id = 'onlyoffice-api-script';
        script.src = `${ONLYOFFICE_URL}/web-apps/apps/api/documents/api.js`;
        script.onload = () => {
          editorRef.current = new window.DocsAPI.DocEditor("onlyoffice-container", {
            document: {
              fileType: fileType,
              key: docKey,
              title: file.name,
              url: url,
              permissions: { edit: false, download: true, print: true }
            },
            documentType: docType,
            editorConfig: { mode: "view", lang: "fr" },
            height: "100%",
            width: "100%",
            type: "desktop",
            token: tokenData.token,
            events: {
              onError: (err) => console.error("OnlyOffice error:", JSON.stringify(err)),
              onAppReady: () => console.log("OnlyOffice app ready"),
            }
          });
        };
        document.head.appendChild(script);

      } catch(e) {
        console.error("Erreur loadEditor :", e);
      }
    };

    loadEditor();

    return () => {
      if (editorRef.current) {
        try { editorRef.current.destroyEditor(); } catch(e) {}
        editorRef.current = null;
      }
      const s = document.getElementById('onlyoffice-api-script');
      if (s) s.remove();
    };
  }, [file, url]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!file || !url) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <span style={styles.filename}>{file.name}</span>
          <button onClick={onClose} style={styles.closeBtn}>✕ Fermer</button>
        </div>
        <div id="onlyoffice-container" ref={containerRef} style={styles.content} />
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  modal: {
    backgroundColor: '#1e1e1e',
    border: '1px solid #2a2a2a',
    borderRadius: '10px', width: '90vw', height: '90vh',
    display: 'flex', flexDirection: 'column', overflow: 'hidden',
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', borderBottom: '1px solid #2a2a2a',
  },
  filename: {
    fontSize: '13px', fontWeight: '500', color: '#f0f0f0',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '70%',
  },
  closeBtn: {
    backgroundColor: 'transparent', border: '1px solid #2a2a2a',
    borderRadius: '4px', padding: '5px 12px', cursor: 'pointer',
    fontSize: '12px', color: '#888',
  },
  content: { flex: 1, overflow: 'hidden' },
};

export default OfficeViewer;